import React from "react";
import "./Loader.css";

export default function Loader() {
  return (
    <div className="loader-container" role="status">
      <div className="loader-spinner" aria-hidden="true" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
